import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleLeft, FaAngleRight, FaBarcode, FaBox, FaBoxOpen, FaCalendarAlt, FaCashRegister, FaChartLine, FaCog, FaEdit, FaEllipsisH, FaEnvelope, FaEye, FaFileDownload, FaFilePdf, FaFileUpload, FaInvision, FaMapMarkerAlt, FaPlus, FaPrint, FaQrcode, FaReceipt, FaSearch, FaStore, FaTag, FaTrash, FaUser, FaWhatsapp } from 'react-icons/fa';
import { Button, Card, CardBody, Col, Container, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Pagination, PaginationItem, PaginationLink, Popover, PopoverBody, Row, Table, Toast, ToastBody, ToastHeader } from 'reactstrap';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import { productActions } from '../../sagas/productSlice';
import { useDispatch, useSelector } from 'react-redux';
import { debounce } from 'lodash';
import { saleActions } from '../../sagas/saleSlice';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { useNavigate } from 'react-router-dom';
import { purchaseActions } from '../../sagas/purchaseSlice';
const BuysReport = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [criteria, setSearchCriteria] = useState({ query: '' });
    const [searchTerm, setSearchTerm] = useState('');
    const [isSearching, setIsSearching] = useState(false);
    const { t } = useTranslation();
    const fileInputRef = useRef(null);
    const dispatch = useDispatch();
    const {
        purchases,
        isLoading,
        totalPages,
        totalElements,
        pageNumber,
        pageSize,
        error,
    } = useSelector((state) => state.purchases);
    const [showReceiptModal, setShowReceiptModal] = useState(false);
    const [selectedSale, setSelectedSale] = useState(null);
    const { businessName, email, address, telephone, fullName } = useSelector(state => state.auth);
    const navigate = useNavigate();
    const [showActions, setShowActions] = useState(false);
    const [popoverOpen, setPopoverOpen] = useState(false);


    // Add handler
    const handleViewDetails = (purchase) => {
        setSelectedSale(purchase);
        setShowReceiptModal(true);
        setPopoverOpen(!popoverOpen);
    };

    useEffect(() => {
        let payload = {
            criteria,
            page: currentPage,
            size: pageSize,
        };
        dispatch(purchaseActions.search(payload));
    }, [currentPage]);


    // Debounced search function
    const debouncedSearch = useCallback(
        debounce((query) => {
            setIsSearching(true);
            dispatch(purchaseActions.search({
                criteria: { query },
                page: 1,
                size: pageSize,
                onSuccess: () => setIsSearching(false)
            }));
        }, 1000), // Wait 500ms after last keystroke
        []
    );

    // Handle search input change
    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        debouncedSearch(value);
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const mapSaleToDTO = (sale) => {
        return {
          id: sale.supplierId,
          description: sale.supplierName,
        };
      };

    const handleGeneratePdf = (sale) => {
        debugger
        const saleDTO = mapSaleToDTO(sale);
        dispatch(purchaseActions.generatePdfRequest(saleDTO));
    };

    // Update price formatting function
    const formatPrice = (amount) => {
        const formattedPrice = new Intl.NumberFormat('fr-MA', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount);
        return `${formattedPrice} DH`;
    };

    const handlePrint = () => {
        const element = document.getElementById('receipt-content');
        html2canvas(element).then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF();
            const imgProps = pdf.getImageProperties(imgData);
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
            pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
            pdf.autoPrint();
            window.open(pdf.output('bloburl'), '_blank');
        });
    };

    const handleToggleActions = (sale) => {
        setSelectedSale(sale);
        setPopoverOpen(!popoverOpen);      };

    return (
        <Container fluid>
            <Row className="mb-3">
                <Col>
                    <Card className="shadow-sm border-0">
                        <CardBody className="py-3">
                            <div className="d-flex justify-content-between align-items-center">
                                <h4 className="mb-0 d-flex align-items-center">
                                    <FaChartLine className="text-primary me-2" />
                                    {t('buy.pageTitle')}
                                </h4>
                                <Button
                                    color="primary"
                                    className="d-flex align-items-center"
                                    onClick={() => navigate('/buys')}
                                    title={t('buy.newSale')}
                                >
                                    <FaPlus className="me-2" />
                                    {t('buy.newBuy')}
                                </Button>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Row>
                <Col md={12} className="pe-4">
                    <Card className="shadow-sm h-100">
                        <CardBody>
                            {isLoading ? (
                                <div className="text-center py-5">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">{t('common.loading')}</span>
                                    </div>
                                    <div className="mt-2 text-muted">
                                        {t('common.loadingData')}
                                    </div>
                                </div>
                            ) : (<>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    {/* Search Input - Left Side */}
                                    <div className="position-relative flex-grow-1 me-3">
                                        <Input
                                            type="text"
                                            placeholder={t('product.searchPlaceholder')}
                                            value={searchTerm}
                                            onChange={handleSearchChange}
                                            className={`ps-4 ${isSearching ? 'searching' : ''}`}
                                        />
                                        <FaSearch
                                            style={{
                                                position: 'absolute',
                                                left: '10px',
                                                top: '12px',
                                                color: '#6c757d'
                                            }}
                                        />
                                    </div>

                                    {/* Buttons - Right Side */}
                                    {/* <div className="d-flex mx-3">
                    <Button
                      color="secondary"
                      size="sm"
                      className="me-2"
                      onClick={downloadTemplate}
                    >
                      <FaFileDownload className="me-2" size={12} />
                      {t('product.downloadTemplate')}
                    </Button>
                    <Button
                      color="primary"
                      size="sm"
                      onClick={() => fileInputRef.current.click()}
                    >
                      <FaFileUpload className="me-2" size={12} />
                      {t('product.uploadProducts')}
                    </Button>
                    <input
                      type="file"
                      ref={fileInputRef}
                      onChange={handleFileUpload}
                      accept=".xlsx,.xls"
                      style={{ display: 'none' }}
                    />
                  </div> */}
                                </div>
                                <div className="table-responsive">
                                    <Table hover bordered className="align-middle mb-0">
                                        <thead className="bg-light">
                                            <tr>
                                                <th className="align-middle">
                                                    <FaReceipt className="me-2 text-primary" size={12} />
                                                    {t('buy.numeroPurchase')}
                                                </th>
                                                <th className="align-middle">
                                                    <FaBox className="me-2 text-primary" size={12} />
                                                    {t('buy.receipt.date')}
                                                </th>
                                                <th className="align-middle text-center">
                                                    <FaInvision className="me-2 text-primary" size={12} />
                                                    {t('buy.receipt.invoiceNb')}
                                                </th>
                                                <th className="align-middle text-center">
                                                    <FaUser className="me-2 text-primary" size={12} />
                                                    {t('buy.receipt.supplier')}
                                                </th>
                                                <th className="align-middle text-center">
                                                    <FaTag className="me-2 text-primary" size={12} />
                                                    {t('purchase.totalTtc')}
                                                </th>

                                                <th className="align-middle text-center" style={{ width: '120px' }}>
                                                    <FaCog className="me-2 text-primary" size={12} />
                                                    {t('common.actions')}
                                                </th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {!purchases || purchases.length === 0 ? (
                                                <tr>
                                                    <td colSpan="6" className="text-center py-4">
                                                        <div className="text-muted">
                                                            {t('product.noProducts')}
                                                        </div>
                                                    </td>
                                                </tr>
                                            ) : (
                                                purchases.map((purchase) => (
                                                    <tr key={purchase.id}>
                                                        <td className="align-middle">{purchase.numero}</td>
                                                        <td className="align-middle">{purchase.createdAt}</td>
                                                        <td className="align-middle text-center">{purchase.buyingInvoiceNb}</td>
                                                        <td className="align-middle text-center">{purchase.supplierName}</td>
                                                        <td className="align-middle text-center">{formatPrice(purchase.totalAmountTtc)}</td>
                                                        <td className="align-middle text-center">
                                                        <span
                                                            id={`Popover-${purchase.id}`}
                                                            title='Afficher les actions'
                                                            onClick={() => handleToggleActions(purchase)}
                                                            className="me-1 px-2 py-1"
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            <FaEllipsisH size={12} className="mr-2" />
                                                        </span>
                                                        <Popover
                                                                placement="bottom"
                                                                isOpen={popoverOpen && selectedSale && selectedSale.id === purchase.id}
                                                                target={`Popover-${purchase.id}`}
                                                                toggle={() => setPopoverOpen(!popoverOpen)}
                                                            >
                                                                <PopoverBody>
                                                                    <Button
                                                                        color="info"
                                                                        size="sm"
                                                                        className="px-2 py-1 me-2"
                                                                        onClick={() => handleViewDetails(purchase)}
                                                                    >
                                                                        <FaEye size={12} />
                                                                    </Button>
                                                                </PopoverBody>
                                                            </Popover>
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                                <div className="d-flex justify-content-between align-items-center mt-3">
                                    <small className="text-muted">
                                        {t('product.showing', {
                                            start: (currentPage - 1) * pageSize + 1,
                                            end: Math.min(currentPage * pageSize, totalElements),
                                            total: totalElements,
                                            currentPage: currentPage,
                                            totalPages: totalElements
                                        })}
                                    </small>
                                    <Pagination size="sm" className="mb-0">
                                        <PaginationItem disabled={currentPage === 1}>
                                            <PaginationLink first onClick={() => handlePageChange(1)}>
                                                <FaAngleDoubleLeft size={12} />
                                            </PaginationLink>
                                        </PaginationItem>
                                        <PaginationItem disabled={currentPage === 1}>
                                            <PaginationLink previous onClick={() => handlePageChange(currentPage - 1)}>
                                                <FaAngleLeft size={12} />
                                            </PaginationLink>
                                        </PaginationItem>
                                        <PaginationItem disabled={currentPage === totalPages}>
                                            <PaginationLink next onClick={() => handlePageChange(currentPage + 1)}>
                                                <FaAngleRight size={12} />
                                            </PaginationLink>
                                        </PaginationItem>
                                        <PaginationItem disabled={currentPage === totalPages}>
                                            <PaginationLink last onClick={() => handlePageChange(totalPages)}>
                                                <FaAngleDoubleRight size={12} />
                                            </PaginationLink>
                                        </PaginationItem>
                                    </Pagination>
                                </div>
                            </>)}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Modal isOpen={showReceiptModal} toggle={() => setShowReceiptModal(false)} size='lg'>
                <ModalHeader toggle={() => setShowReceiptModal(false)}>
                    {t('receipt.title')}
                </ModalHeader>
                <ModalBody>
                    <div
                        id="receipt-content"
                        className="p-4 bg-white shadow-sm rounded"
                        style={{ width: '100%' }}
                    >
                        {/* Header */}
                        <div className="text-center mb-4">
                            <h5 className="mb-2">
                                <FaStore className="me-2 text-secondary" />
                                {businessName}
                            </h5>
                            <small className="d-block mb-2">
                                <FaMapMarkerAlt className="me-1 text-secondary" />
                                {address}
                            </small>
                            <div className="d-flex justify-content-center align-items-center gap-3">
                                {telephone && (
                                    <small>
                                        <FaWhatsapp className="me-1 text-secondary" />
                                        {telephone}
                                    </small>
                                )}
                                <small>
                                    <FaEnvelope className="me-1 text-secondary" />
                                    {email}
                                </small>
                            </div>
                        </div>

                        <hr />

                        {/* Receipt Details */}
                        <div className="mb-3">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <div>
                                    <FaReceipt className="me-2 text-secondary" />
                                    <span className="fw-bold">{t('sale.receipt.receiptNo')}: </span>
                                    {selectedSale?.numero}
                                </div>
                                <div>
                                    <FaCalendarAlt className="me-2 text-secondary" />
                                    <span className="fw-bold">{t('sale.receipt.date')}: </span>
                                    {selectedSale?.createdAt}
                                </div>
                            </div>
                            <div className="d-flex justify-content-between align-items-center mb-2">
                            <div>
                                <FaUser className="me-2 text-secondary" />
                                <span className="fw-bold">{t('sale.receipt.cashier')}: </span>
                                {fullName}
                            </div>
                            <div>
                                <FaUser className="me-2 text-secondary" />
                                <span className="fw-bold">{t('buy.receipt.supplier')}: </span>
                                {selectedSale?.supplierName}
                            </div>
                            </div>
                        </div>

                        <hr />

                        {/* Products Table */}
                        <table className="table table-sm">
                            <thead>
                                <tr>
                                    <th>{t('product.description')}</th>
                                    <th className="text-end">{t('buy.receipt.price')}</th>
                                    <th className="text-end">{t('buy.receipt.quantity')}</th>
                                    <th className="text-end">{t('buy.receipt.totalHt')}</th>
                                    <th className="text-end">{t('buy.receipt.tax')}</th>
                                    <th className="text-end">{t('buy.receipt.totalTtc')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {selectedSale && selectedSale.lines.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.productName}</td>
                                        <td className="text-end">{formatPrice(item.unitPrice)}</td>
                                        <td className="text-end">{item.quantity}</td>
                                        <td className="text-end">{formatPrice(item.unitPrice * item.quantity)}</td>
                                        <td className="text-end">{selectedSale.taxRate.split('_')[1]}%</td>
                                        <td className="text-end">{formatPrice((item.unitPrice * item.quantity)*1.2)}</td>

                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        <hr />

                        {/* Totals */}
                        <div className="text-end mb-4">
                            <div className="mb-2">
                            <span className="fw-bold me-3">{t('buy.receipt.totalHt')}:</span>
                            {formatPrice(selectedSale?.totalAmountHt)}
                          </div> 
                             <div className="mb-2">
                            <span className="fw-bold me-3">{t('buy.receipt.tax')}:</span>
                            {formatPrice(selectedSale?.totalAmountTtc - selectedSale?.totalAmountHt)}
                          </div>
                            <div className="mb-2">
                                <span className="fw-bold me-3">{t('buy.receipt.totalTtc')}:</span>
                                {formatPrice(selectedSale?.totalAmountTtc)}
                            </div>
                            {selectedSale?.state === 'PARTIEL' && (
                                <>
                                    <div className="mb-2" style={{ color: 'red' }}>
                                    <span className="fw-bold me-3">{t('buy.receipt.advance')}:</span>
                                    -{formatPrice(selectedSale?.advancePayment)}
                                    </div>
                                    <div className="mb-2">
                                    <span className="fw-bold me-3">{t('buy.receipt.rest')}:</span>
                                    {formatPrice(selectedSale?.remainingAmount)}
                                    </div>
                                </>
                                )}

                        </div>

                        {/* Footer */}
                        <div className="text-center mt-4">
                            <p className="mb-1">{t('buy.receipt.thankYou')}</p>
                            <small className="text-muted">{t('buy.receipt.footer')}</small>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handlePrint}>
                        <FaPrint className="me-1" />
                        {t('receipt.printBill')}
                    </Button>
                </ModalFooter>
            </Modal>
        </Container>

    );
};

export default BuysReport;
